import React from 'react';
import { Link } from 'react-router-dom';
import ill_girl_with_dress from '../images/ill-girl-with-dress.png';
import ill_okay from '../images/ill-ok.png';
import PortalButton from '../components/Button';
function Thankyou2() {
  return (
    <main className="bg-white">
      <div className="relative md:flex">
        <div className="hidden lgg:grid grid-cols-1 gap-2 place-items-center  w-full lgg:w-1/2 lgg:bg-statustext-600 rounded-r-[70px] lgg:h-[900px]">
          <div className="inline-flex">
            <img src={ill_girl_with_dress} className="px-48 z-10" alt="404 illustration" />
            <div className="bg-statustext-800 absolute bottom-0 w-1/2 h-1/2 rounded-t-full"></div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 place-items-center w-full lgg:w-1/2 lgg:h-[900px]">
          <div className=" inline-flex">
            <div className="max-w-md mx-auto px-2 py-8">
              <div className="text-center lgg:text-left text-lg">
                <div className="flex justify-center lgg:justify-start">
                  <img className="w-16" src={ill_okay} />
                </div>
                <div className="text-xl lgg:text-3xl font-semibold text-portal-600 py-4 ">Thanks You for Accepting!</div>
                <div className="font-semibold text-md lgg:text-xl py-2">We’re happy to have you on board!</div>
                <div className="pb-1 text-md lgg:text-xl py-2">
                  We’ll send you onboarding information <br />
                  in 24-48 hours.
                </div>
                <div className="pb-1 text-md lgg:text-xl py-2">
                  Don’t hestiate to <span className="text-portal-300 font-semibold">contact us</span> if you have any questions or
                  concerns.
                </div>
                {/* <div className="flex justify-center mt-10">
                  <div className="w-1/3">
                    <PortalButton
                      variant="primary"
                      text="Done"
                      onClick={() =>
                        setOfferAcceptOpen(!OfferAcceptOpen)
                      }></PortalButton>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="lgg:hidden grid grid-cols-1 gap-2 place-items-center w-full lgg:w-1/2 ">
          <div className="inline-flex">
            <img src={ill_girl_with_dress} className="px-24 py-8" alt="404 illustration" />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Thankyou2;
